import axios from "axios";
import React, { useState } from "react";
import swal from "sweetalert";
import Dropzone from "react-dropzone";
import uploadThumb from "../../assets/upload.svg";
import { Modalprogress } from "../Modal/Modalprogress";
import { Modalsuccessfile } from "../Modal/Modalsuccessfile";
import fileThumb from "../../assets/file.svg";
import { getFileHash } from "../../utils/utils";
const { REACT_APP_API_URL, REACT_APP_PROFILE_ADDRESS } = process.env;

const UpdatedocInput = () => {
  const [file, setFile] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const [identifier, setIdentifier] = useState();
  const [newidentifier, setNewIdentifier] = useState();
  const [loading, setLoading] = useState(false);
  const [blockHash, setBlockHash] = useState();
  const [hash, setHash] = useState();

  const handleFile = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    setFile(file);
    const hash = await getFileHash(file);
    setHash(hash);
  };

  const updateDoc = async () => {
    if (identifier && hash) {
      try {
        const response = await axios.put(
          `${REACT_APP_API_URL}/doc-hash/update`,
          {
            identifier: identifier,
            fileHash: hash,
            address: REACT_APP_PROFILE_ADDRESS,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${process.env.CLIENT_TOKEN}`,
            },
            validateStatus: (status) => status < 500,
          }
        );
        if (response.status === 200) {
          setLoading(false);
          setNewIdentifier(response.data.result.identifier);
          setBlockHash(response.data.result.blockHash);
          setFile();
          setHash();
          setIdentifier();
          setSuccessModal(true);
        } else if (response.status === 400) {
          setLoading(false);
          swal({
            title: "Unable to update",
            text: response.data.err || "An error occurred",
            icon: "error",
          });
        } else {
          setLoading(false);
          swal({
            title: "Unable to update",
            text: response.data.error || "An unknown error occurred",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error updating document:", error);
      }
    } else {
      swal({
        title: "Please enter the identifier",
        text: "Please enter a valid identifier",
        icon: "error",
      });
    }
  };
  return (
    <div>
      <Modalprogress
        loading={loading}
        msg={[
          "Checking identifier...",
          "Updating & Anchoring digest to chain...",
        ]}
      />
      <Modalsuccessfile
        loading={successModal}
        msg={"Updated Successfully"}
        txtmsg={
          "Document successfully updated on  weavenet.cord.network chain."
        }
        Identifier={newidentifier}
        blockhash={blockHash}
        onClose={() => {
          setSuccessModal(false);
        }}
      />
      <div className="row mt-5 mx-0">
        <div className="col-md-8 justify-content-center mx-auto">
          <p className=" mt-3 fw-bolder">Enter the Identifier</p>
          <div className="input-wrapper">
            <input
              type="text"
              name="text"
              className="input"
              placeholder="Identifier"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            />
          </div>
          <p className="text-left mt-2 subtxt">
            Note: To update an existing file, enter the identifier and upload a
            new file. This will securely update its digital fingerprint on the
            blockchain
          </p>
        </div>
      </div>
      <div className="row mt-5 mx-0">
        <div className="col-md-4 justify-content-center mx-auto d-flex  ">
          {file ? (
            <>
              <div className="filebox justify-content-between d-flex">
                <img
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  src={fileThumb}
                  alt={`upload icon`}
                />
                <div className="mt-2">
                  <p className="m-0"> Filename : {file.name}</p>
                  <p className="m-0">Filetype: {file.type}</p>
                </div>
                <div
                  className="cursor-pointer font-text-bold "
                  style={{ fontSize: "Medium" }}
                  onClick={() => {
                    setHash();
                    setFile();
                  }}
                >
                  X
                </div>
              </div>
            </>
          ) : (
            <Dropzone onDrop={(acceptedFiles) => handleFile(acceptedFiles)}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()} className="fileboxinput">
                    <input {...getInputProps()} />

                    <div className="d-flex flex-column justify-content-center align-items-center align-conent-center">
                      <img
                        style={{
                          maxWidth: "50px",
                          maxHeight: "50px",
                          paddingBottom: "10px",
                        }}
                        src={uploadThumb}
                        alt={`upload icon`}
                      />
                      <p className="drapdroptxt">Drag & drop any file here</p>
                    </div>
                  </div>
                </section>
              )}
            </Dropzone>
          )}
        </div>
        <p className="text-center mt-3 fw-bolder">
          Upload your file to securely update its unique digital fingerprint on
          the blockchain.
        </p>
      </div>
      <div className="row mt-5 mx-0">
        <div className="col-md-4 justify-content-center mx-auto d-flex  ">
          <button
            className="btn btn-primary mb-3 mr-5p btn-sub"
            disabled={
              identifier && identifier.length > 0 && hash ? false : true
            }
            onClick={() => {
              setLoading(true);
              setTimeout(() => {
                updateDoc();
              }, [6000]);
            }}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatedocInput;
